// extracted by mini-css-extract-plugin
module.exports = {"headnote":"_9e1425b4d3--headnote--dyqsx","comment":"_9e1425b4d3--comment--RiRpL","footnote":"_9e1425b4d3--footnote--EoShJ"};